/* eslint-disable */
const theme = require('./theme');

// keep below interface for future potential requirements 
/* eslint-disable */
const themePlaceholder = {}; 

module.exports = Object.assign({}, theme, themePlaceholder);
